.grid {
  grid-template-columns: repeat(4, 1fr);
}

.option {
  height: 112px;
  padding: 24px 12px;
}

@media (--reefer-media-tablet-max) {
  .grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .option {
    height: 104px;
    padding: 12px;
  }
}
